import { notification } from 'antd';

export const error403Config = [
  {
    match: (url: string) => url.includes('/author-sales'),
    handler: () => ({ data: null }) // silent
  },
  {
    match: () => true, // fallback
    handler: (error) => {
      notification.error({
        description:
          error.response?.data?.error ||
          'You do not have permission to access this resource',
        message: error.message
      });
      throw error;
    }
  }
];

export const error400Config = [
  {
    match: (url: string) =>
      ['search/all', 'edit-custom-object', 'create-custom-object']
        .some(p => url.includes(p)),
    handler: (error) => error.response.data
  },
  {
    match: (url: string) => url.includes('manually'),
    handler: (error) => error.response
  },
  {
    match: (url) => url.includes('/author-sales'),
    handler: () => ({ data: null }) // silent
  }
];